// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3BND3","colMin":"styles_colMin__2qyHS","colCheckbox":"styles_colCheckbox__xUNah"};